/**
 * @module hotornot/config/routes
 */
import {main} from '../../core/service/location.js';
import {path, createMany, index, alias, expr} from '@acng/frontend-voyager';
import {onlyUser} from 'acng/userPool/config/middleware';
import {on} from '@acng/frontend-bounty';
import {trackOncePerMinute} from 'acng/userPool/service/activity.js';
import {mainView, stickyView} from 'acng/layout/service/sequence.js';
import {feature} from '../service/template.js';

const base = main.create(
  onlyUser,
  path('/hotornot'), //
  alias('hotOrNotBase'),
  createMany(
    [index, alias('hotOrNot')], //
    [path('/votes'), mainView(feature, 'votes'), stickyView(feature, 'list-header')],
    [path('/matches'), mainView(feature, 'matches'), stickyView(feature, 'list-header')],
  ),
);

runTracking.$inject = ['user'];
/**
 * @param {import('acng/userPool/factory/user').User} user -
 */
export function runTracking(user) {
  on(base, 'active', trackOncePerMinute);
}
